import { render, staticRenderFns } from "./PageImageConfig.vue?vue&type=template&id=3a0edf84"
import script from "./PageImageConfig.vue?vue&type=script&lang=js"
export * from "./PageImageConfig.vue?vue&type=script&lang=js"
import style0 from "./PageImageConfig.vue?vue&type=style&index=0&id=3a0edf84&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports